import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { HttpService } from "../http.service";
import { ExportSurveyDto } from "../Models/write/ExportSurveyDto";
import { APIEndpoints } from "../../../config/apiEndpoint.config";

@Injectable({
  providedIn: "root",
})
export class AdminPanelCsvService {
  headers: HttpHeaders;
  areaId: string;

  constructor(
    private httpService: HttpService,
    private _httpClient: HttpClient
  ) {
    this.headers = new HttpHeaders();
    this.headers.set("Content-Type", "application/json");
  }

  triggerCsv(data: ExportSurveyDto) {
    return this.httpService.postWithFileResponse(
      APIEndpoints.exportSurvey,
      data
    );
  }
}
